/* index.js */

"use strict";
const Steve = require("@gluenetworks/steve_core").getInstance();
const Registrations = require("./src/Registrations");
/**********************************************************************/
/* START STEVE PART Registrations */
/**********************************************************************/
//-------- Report Center Section --------
const ReportCenter = require("./src/app/ReportCenterSectionComponent");
Steve.di.registry.register(Registrations.REPORT_CENTER_SECTION, ReportCenter);

//-------- EDTIORS AND EDITOR PARTS--------
//Report Generator Editor
const ReportGeneratorEditor = require("./src/app/editors/reportgeneratoreditor/ReportGeneratorEditorComponent");
Steve.di.registry.register(Registrations.REPORT_GENERATOR_EDITOR, ReportGeneratorEditor);

/**********************************************************************/
/* END STEVE PART Registrations */
/**********************************************************************/
module.exports = ReportCenter;
